import builder from '../builder';
import OfficeFilePDF from '../../streamline-icons/bold/office-file-pdf-1.svg';

export default builder('OfficeFilePDFBold', OfficeFilePDF);
